module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "loading": _vm.loading,
      "paginated": "",
      "backend-pagination": "",
      "total": _vm.total,
      "per-page": _vm.perPage,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page",
      "backend-sorting": "",
      "default-sort-direction": _vm.defaultSortOrder,
      "default-sort": [_vm.sortField, _vm.sortOrder]
    },
    on: {
      "page-change": _vm.onPageChange,
      "sort": _vm.onSort
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "original_title",
            "label": "Title",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.original_title) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_average",
            "label": "Vote Average",
            "numeric": "",
            "sortable": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          class: _vm.type(props.row.vote_average)
        }, [_vm._v("\n                        " + _vm._s(props.row.vote_average) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_count",
            "label": "Vote Count",
            "numeric": "",
            "sortable": ""
          }
        }, [_vm._v("\n                     " + _vm._s(props.row.vote_count) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "release_date",
            "label": "Release Date",
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.release_date ? new Date(props.row.release_date).toLocaleDateString() : '') + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Overview",
            "width": "500"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("truncate")(props.row.overview, 80)) + "\n                ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3e9e60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExAsyncData.vue
// module id = 1227
// module chunks = 1 92